import type { i18n as I18n } from 'i18next';

// The six the picker offers, plus the red heart that replaces the green one
// off-brand. These are what nearly every reaction is, so they are translated:
// an English word inside a Swedish sentence is not a name a screen reader can
// read properly.
const NAMED_EMOJI: Record<string, string> = {
    '+1': 'emoji.thumbs_up',
    tada: 'emoji.party_popper',
    eyes: 'emoji.eyes',
    joy: 'emoji.face_with_tears_of_joy',
    green_heart: 'emoji.green_heart',
    heart: 'emoji.red_heart',
    white_check_mark: 'emoji.check_mark',
};

// Anything reacted with from the full picker instead. The shortcode is all we
// have, so its punctuation is stripped and that is read out -- in English,
// whatever the locale. Better than "colon plus one colon", short of a name.
const SPELLED_OUT: Record<string, string> = {
    '-1': 'thumbs down',
};

/**
 * Turns an emoji shortcode into something worth hearing.
 *
 * The shortcodes carry their delimiters and underscores, so a screen reader
 * reads ':green_heart:' as "colon green underscore heart colon".
 */
export const getEmojiName = (i18next: I18n, shortcode: string) => {
    const bare = shortcode.replace(/:/g, '');
    const key = NAMED_EMOJI[bare];

    if (key) {
        return i18next.t(key);
    }

    return SPELLED_OUT[bare] ?? bare.replace(/_/g, ' ');
};
